import React, { VFC } from 'react';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types';
import { formPageIdentifierClass } from '../../../../constants/multiStep.constants';

const FormPageIdentifierField: VFC<ValueFieldProps> = (props) => {
  const { field } = props;
  const id = field?.valueField?.id;
  const name = field?.valueField?.name;
  const itemId = field?.fieldIdField?.value; 
  
  return <input id={id} name={name} className={`sitecore-jss-form__field ${formPageIdentifierClass}`} type="hidden" value={itemId} form="novalidatedform" />;
};

export default FormPageIdentifierField;